import styled, { keyframes } from 'styled-components';

import themes from '../../styles/theme';

export const Container = styled.div`
  margin: 3% auto 0px;
  max-width: 1038px;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  background-color: ${themes.bgWhite};
  padding: 30px;
  display: 'none';
  max-height: 350px;
  min-height: 450px;
  height: 350px;
`;
export const ContButton = styled.div`
  padding-left: 87%;
  display: 'none';
`;
export const InlineContainer = styled.div`
  display: flex;
`;
const rotate = keyframes`
    from{
        transform: rotate(0deg);
    }

    to{
        transform: rotate(360deg);
    }
`;

export const ContainerEmptyContent = styled.div`
  text-align: left;
  font: 300 16px 'Calibri';
  letter-spacing: 1.12px;
  color: #5a5a5a;
  opacity: 1;

  svg {
    animation: ${rotate} 2s linear infinite;
  }
`;
